import { Header, Segment, Message, Button } from 'semantic-ui-react';
import { buildUrl, AppRoutes } from '../AppRoutes';
import { useNavigate } from 'react-router';
import { BPButton } from '@/components/bp/bpbutton';

export const Lockout: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="auth-container">
            <Header as="h1">Locked out</Header>
            <Segment>
                <Message warning>
                    <Message.Header>This account has been locked out</Message.Header>
                    <p>This account has been locked out, please try again later.</p>
                </Message>
                <div>
                    <BPButton 
                        onClick={() => navigate(buildUrl(AppRoutes.Login, {}))}
                    >
                        Return to Login
                    </BPButton>
                </div>
            </Segment>
        </div>
    );
};